import { useEffect, useState } from 'react'
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';
import { toast } from 'react-toastify';

export interface AssignmentInputProps {
  estimatedTime: number;
  onEstimatedChange: (value: number) => void;
  scheduleId: string;
  initclassnameE: string,
  isEstimatedDisabled: boolean,
  initvalueRealTime: number,
  initclassnameR: string,
  isRealTimeDisabled: boolean,
  setEditedRealTimes: React.Dispatch<React.SetStateAction<{ [scheduleId: string]: number }>>,
  // Nuevas props para validación
  taskId?: string;
  date?: string;
  validateHourInput?: (taskId: string, date: string, hours: number) => boolean;
}

export const AssignmentInput = ({
  estimatedTime,
  onEstimatedChange,
  initclassnameE,
  isEstimatedDisabled,
  initvalueRealTime,
  initclassnameR,
  isRealTimeDisabled,
  setEditedRealTimes,
  scheduleId,
  taskId,
  date,
  validateHourInput,
}: AssignmentInputProps) => {
  const [classnameE, setClassnameE] = useState(initclassnameE)
  const [realTime, setRealTime] = useState<number | "">(
    isNaN(initvalueRealTime) ? "" : initvalueRealTime
  );
  const [classnameR, setClassnameR] = useState(initclassnameR)

  useEffect(() => {
    setRealTime(isNaN(initvalueRealTime) ? "" : initvalueRealTime);
    setClassnameR(initclassnameR);
  }, [initvalueRealTime, initclassnameR]);


  const handleChangeRealTime = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setRealTime(ev.target.value === "" ? "" : parseFloat(ev.target.value));
  };

  const handleSaveRealTime = () => {
    if (isRealTimeDisabled) return;

    const numericValue = realTime === "" ? 0 : Number(realTime);

    if (numericValue === initvalueRealTime) {
      return;
    }

    if (scheduleId.startsWith("new-") && numericValue > 0) {
      toast.error("No puedes registrar tiempo real porque no hay tiempo estimado asignado para este día.");
      setRealTime(isNaN(initvalueRealTime) ? "" : initvalueRealTime);
      return;
    }

    if (!isNaN(numericValue) && numericValue >= 0) {
      setClassnameR(assignmentsStyles["assigncalentask__edited"]);
      setEditedRealTimes(prev => ({
        ...prev,
        [scheduleId]: numericValue,
      }));
    } else {
      toast.error("Ingrese un valor válido entre 0 y 24.");
      setRealTime(isNaN(initvalueRealTime) ? "" : initvalueRealTime);
    }
  };

  const getEstimatedInputClass = () => {
    if (classnameE === assignmentsStyles["assigncalentask__edited"]) {
      return assignmentsStyles["assigncalentask__edited"];
    }
    if (estimatedTime === 0 || estimatedTime === null) {
      return assignmentsStyles["assigncalentask__empty"];
    }
    return assignmentsStyles["assigncalentask__est"];
  };

  return (
    <div className={assignmentsStyles["assigncalentask__day"]}>
      <input
        type="number"
        min="0"
        max="10"
        step="0.5"
        value={estimatedTime}
        className={getEstimatedInputClass()}
        disabled={isEstimatedDisabled}
        onInput={e => {
          // Prevenir entrada de valores > 10 a nivel de input
          const target = e.target as HTMLInputElement;
          const value = Number(target.value);
          if (value > 10) {
            target.value = "10";
          }
        }}
        onChange={e => {
          const newValue = Number(e.target.value);
          
          // Validación básica inmediata
          if (newValue > 10) {
            toast.error("No se pueden asignar más de 10 horas diarias por tarea.");
            e.target.value = estimatedTime.toString();
            return;
          }
          
          // Validación completa INMEDIATA (incluyendo totales diarios)
          if (validateHourInput && taskId && date) {
            if (!validateHourInput(taskId, date, newValue)) {
              // Si la validación falla, revertir al valor anterior TANTO en DOM como en estado
              e.target.value = estimatedTime.toString();
              // NO llamar onEstimatedChange para mantener el valor anterior
              console.log(`❌ VALIDATION BLOCKED: Keeping previous value ${estimatedTime}h`);
              return;
            }
          }
          
          // Solo aplicar cambio si pasa todas las validaciones
          console.log(`✅ VALIDATION PASSED: Accepting ${newValue}h`);
          onEstimatedChange(newValue);
          setClassnameE(assignmentsStyles["assigncalentask__edited"]);
        }}
        onBlur={e => {
          // Validación de respaldo al salir del campo (por si acaso)
          const newValue = Number(e.target.value);
          
          if (newValue > 10) {
            e.target.value = "10";
            onEstimatedChange(10);
            toast.error("Valor corregido automáticamente a 10 horas máximo.");
          }
        }}
        name='estimatedTime'
        placeholder="0"
      />
      <input
        name='realTime'
        type='number'
        value={realTime}
        className={classnameR}
        readOnly={isRealTimeDisabled}
        onChange={handleChangeRealTime}
        onBlur={handleSaveRealTime}
      />
    </div>
  )
}